// src/pages/Login.jsx
import { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import api from "../api/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   setLoading(true);

  //   try {
  //     const res = await api.post("/auth/login", { email, password });

  //     // Backend sirf token bhej raha hai
  //     const token = res.data.token;
  //     // Token ko decode karke user fetch karna backend me hoga 
  //     // lekin yahan ke liye assume user details aap context me set karenge
  //     const userData = { email }; // Placeholder (aap backend se user bhi return kara sakte ho)

  //     login(userData, token);

  //     // Role ke basis pe redirect (yahan ke liye hardcoded check kar rahe)
  //     if (userData.role === "admin") {
  //       navigate("/admin-dashboard");
  //     } else {
  //       navigate("/user-dashboard");
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || "Login failed");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


 const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    const res = await api.post("/auth/login", { email, password });
  login(res.data); // ab token + user dono milenge
  if (res.data.user.role === "admin") {
    navigate("/dashboard");
  } else {
    navigate("/dashboard");
  }
  } catch (err) {
    setError(err.response?.data?.message || "Login failed");
  } finally {
    setLoading(false);
  }
};





  return (
    <div className="flex items-center justify-center min-h-screen ">
      <form
        onSubmit={handleSubmit}
        className=" p-6 rounded-lg shadow-lg w-96"
      >
        <h2 className="text-2xl font-bold mb-4 text-center text-gray-100">
          Login
        </h2>
        {error && <p className="text-red-500 mb-3 text-center">{error}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 border rounded mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100"
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onError={"please enter atleast 6 gitis of passwords"}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 border rounded mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent text-gray-100"
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <div className="text-sm text-center mt-4">
          <Link
            to="/reset-password"
            className="text-blue-600 hover:underline"
          >
            Forgot Password?
          </Link>
        </div>
      </form>
    </div>
  );
}
